<script lang="ts">
    import { page } from '$app/state';
    import NotFound from '$lib/layouts/errors/NotFound.svelte';
    import InternalError from '$lib/layouts/errors/InternalError.svelte';
</script>

{#if page.status === 404}
    <NotFound market={page.data.market} />
{:else}
    <InternalError />
{/if}
{#if page.error?.errorId}
    <div class="hidden" data-error-id={page.error.errorId}>{page.error.errorId}</div>
{/if}
